(function () {
  if (window.__vhCopyCoupon) return;
  window.__vhCopyCoupon = true;

  function setLabel(button, text) {
    const label = button.querySelector('[data-vh-copy-label]');
    if (label) label.textContent = text;
  }

  async function copyCoupon(button) {
    const code = button.getAttribute('data-vh-copy-coupon');
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
      setLabel(button, 'Copiado');
      button.classList.add('is-copied');
      window.setTimeout(() => {
        setLabel(button, 'Copiar');
        button.classList.remove('is-copied');
      }, 1800);
    } catch (_) {
      setLabel(button, code);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vh-copy-coupon]');
    if (!button) return;
    copyCoupon(button);
  });
})();
